import type { NotFoundPageProps } from './const';
import { cn } from '../../utils';
import './index.less';

function NotFoundPage(props: NotFoundPageProps) {
  const {
    className,
    style,
    title = 'Page not found',
    description = 'Sorry, the page you\'re looking for doesn\'t exist or has been removed',
    backButton,
  } = props;

  return (
    <div className={cn('wg-not-found', className)} style={style}>
      <div className="wg-not-found__icon">
        <svg xmlns="http://www.w3.org/2000/svg" width="200" height="200" viewBox="0 0 200 200" fill="none">
          <text x="50%" y="50%" textAnchor="middle" dominantBaseline="middle" fontSize="80" fontWeight="800" fill="#1a202c">
            404
          </text>
        </svg>
      </div>

      <div className="wg-not-found__title">{title}</div>

      <div className="wg-not-found__text">{description}</div>

      {backButton}
    </div>
  );
}

export default NotFoundPage;
export type { NotFoundPageProps };
